<h1>Games</h1>
<div class="d-flex flex-row flex-wrap justify-content-center align-items-center">
  <div class="p-5">
    <a [routerLink]="['play']" [queryParams]="{game: 'aviator'}">
      <img class="gameimg" src="../../../../assets/aviator.jpg" />
      <h2>Aviator 2.0</h2>
    </a>
  </div>
  <div class="p-5">
    <a [routerLink]="['play']" [queryParams]="{game: 'stroopeffect'}">
      <img class="gameimg" src="../../../../assets/stroop-effect.png" />
      <h2>Stroop Effect</h2>
    </a>
  </div>
  <div class="p-5">
    <a [routerLink]="['play']" [queryParams]="{game: 'hextris'}">
      <img class="gameimg" src="../../../../assets/hextris.png" />
      <h2>Hextris</h2>
    </a>
  </div>
  <div class="p-5">
    <a [routerLink]="['play']" [queryParams]="{game: 'repeatthesound'}">
      <img class="gameimg" src="../../../../assets/repeat-the-sound.png" />
      <h2>Repeat the Sound</h2>
    </a>
  </div>
  <div class="p-5">
    <a [routerLink]="['play']" [queryParams]="{game: '2048'}">
      <img class="gameimg" src="../../../../assets/2048.png" />
      <h2>2048</h2>
    </a>
  </div>
  <div class="p-5">
    <a [routerLink]="['play']" [queryParams]="{game: 'jump'}">
      <img class="gameimg" src="../../../../assets/jump.jpg" />
      <h2>Jump</h2>
    </a>
  </div>
  <div class="p-5">
    <a [routerLink]="['play']" [queryParams]="{game: 'tetris'}">
      <img class="gameimg" src="../../../../assets/tetris.png" />
      <h2>Tetris</h2>
    </a>
  </div>
  <div class="p-5">
    <a [routerLink]="['play']" [queryParams]="{game: '8puzzle'}">
      <img class="gameimg" src="../../../../assets/8puzzle.png" />
      <h2>8 Puzzle</h2>
    </a>
  </div>
  <div class="p-5">
    <a [routerLink]="['play']" [queryParams]="{game: 'bubbleshooter'}">
      <img class="gameimg" src="../../../../assets/bubbleshooter.png" />
      <h2>Bubble Shooter</h2>
    </a>
  </div>
  <div class="p-5">
    <a [routerLink]="['play']" [queryParams]="{game: 'theaviator'}">
      <img class="gameimg" src="../../../../assets/aviator.jpg" />
      <h2>Aviator</h2>
    </a>
  </div>
  <div class="p-5">
    <a [routerLink]="['play']" [queryParams]="{game: 'hangman'}">
      <img class="gameimg" src="../../../../assets/hangman.jpg" />
      <h2>Hangman</h2>
    </a>
  </div>
  <div class="p-5">
    <a [routerLink]="['play']" [queryParams]="{game: 'jumpsquare'}">
      <img class="gameimg" src="../../../../assets/square.png" />
      <h2>Square Jump</h2>
    </a>
  </div>
  <div class="p-5">
    <a [routerLink]="['play']" [queryParams]="{game: 'wordguessing'}">
      <img class="gameimg" src="../../../../assets/wordguess.png" />
      <h2>Word Guess</h2>
    </a>
  </div>
</div>